/**
 * Formatea una fecha de manera relativa:
 * - Si fue hoy: "Hoy a las HH:MM"
 * - Si fue ayer: "Ayer a las HH:MM"
 * - Si fue antes: "DD/MM/YYYY a las HH:MM"
 */
export const formatRelativeDate = (dateString: string): string => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  const orderDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  
  const timeString = date.toLocaleTimeString('es-CL', { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: false 
  });
  
  if (orderDate.getTime() === today.getTime()) {
    return `Hoy a las ${timeString}`;
  } else if (orderDate.getTime() === yesterday.getTime()) {
    return `Ayer a las ${timeString}`;
  } else {
    const dateString = date.toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    return `${dateString} a las ${timeString}`;
  }
};

/**
 * Obtiene la fecha de creación de un pedido
 * Soporta múltiples formatos de campo (created_at, createdAt)
 */
export const getOrderDate = (order: { created_at?: string; createdAt?: string }): string => {
  return order.created_at || order.createdAt || '';
};

